export const DISCOUNTS = [
  { label: 'No Discount', value: 0 },
  { label: 'SM Graft Promo', value: 500 },
  { label: 'MD Graft Promo', value: 750 },
  { label: 'LG Graft Promo', value: 1000 },
  { label: 'MaxGraft Promo', value: 1500 },
  { label: 'Event Promo', value: 2000 },
];

export const DEFAULT_BUNDLE_DISCOUNT = {
  label: 'Bundle',
  value: 5151,
};

export const PRP_BUNDLE_DISCOUNT = {
  label: 'Bundle',
  value: 150,
};
